import { css } from 'styled-components';

export const ColorsVariables = {
	MainPurple: '#7F84FF',
	MainGreen: '#73D79F',
	LightGreen: '#87DFAE',
	MainRed: '#F32000',
	MainBlack: 'black',
};

export const Colors = Object.entries(ColorsVariables).reduce((acc, value) => {
	const [name, color] = value;
	acc[name] = css`color: ${color};`;
	return acc;
}, {});

export const BackgroundColors = Object.entries(ColorsVariables).reduce((acc, value) => {
	const [name, color] = value;
	acc[name] = css`background-color: ${color};`;
	return acc;
}, {});
